import { useState, type FormEvent } from "react";
import { useAuth } from "./AuthContext";
import { appConfig } from "./config";
import { Button, Callout, Field, Input, Spinner } from "../shared/ui/Primitives";

export function LoginScreen() {
  const {
    loading,
    error,
    retry,
    devLoginAvailable,
    loginWithBitrixId,
    loginWithPassword,
  } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [bitrixUserId, setBitrixUserId] = useState(String(appConfig.devBitrixUserId));
  const [submitting, setSubmitting] = useState<"password" | "dev" | null>(null);

  async function submitPassword(event: FormEvent) {
    event.preventDefault();
    if (!email.trim() || !password) return;
    setSubmitting("password");
    try {
      await loginWithPassword(email, password);
    } finally {
      setSubmitting(null);
    }
  }

  async function submitDev(event: FormEvent) {
    event.preventDefault();
    const userId = Number(bitrixUserId);
    if (!Number.isInteger(userId) || userId < 1) return;
    setSubmitting("dev");
    try {
      await loginWithBitrixId(userId);
    } finally {
      setSubmitting(null);
    }
  }

  return (
    <main className="login-screen">
      <section className="login-card">
        <header className="login-brand">
          <div className="brand-mark" aria-hidden="true">S</div>
          <div>
            <span>STREAMER</span>
            <h1>{appConfig.appTitle}</h1>
            <p>Рабочее пространство технической службы</p>
          </div>
        </header>

        {loading && !submitting ? (
          <div className="login-progress"><Spinner /><span>Проверяем серверную сессию…</span></div>
        ) : null}
        {error ? <Callout tone="danger" title="Вход не выполнен">{error}</Callout> : null}

        <div className="login-methods">
          <section className="login-method">
            <div>
              <h2>Вход через Bitrix24</h2>
              <p>Откройте приложение в портале — профиль и права будут подтверждены автоматически.</p>
            </div>
            <Button variant="secondary" icon="refresh" onClick={() => void retry()} disabled={loading}>
              Проверить сессию
            </Button>
          </section>

          <div className="login-divider"><span>или</span></div>

          <form onSubmit={submitPassword} className="login-method login-method--form">
            <div>
              <h2>Вход по почте</h2>
              <p>Используется тот же внутренний аккаунт, роли и история работы.</p>
            </div>
            <Field label="Корпоративная почта">
              <Input
                type="email"
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="name@streamer.ru"
                required
              />
            </Field>
            <Field label="Пароль">
              <Input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </Field>
            <Button type="submit" disabled={!email.trim() || !password || submitting !== null}>
              {submitting === "password" ? "Входим…" : "Войти"}
            </Button>
          </form>
        </div>

        {devLoginAvailable ? (
          <details className="dev-login">
            <summary>Локальный режим разработки</summary>
            <form onSubmit={submitDev} className="inline-form">
              <Input
                aria-label="Bitrix user ID"
                type="number"
                min="1"
                value={bitrixUserId}
                onChange={(event) => setBitrixUserId(event.target.value)}
              />
              <Button type="submit" variant="secondary" disabled={submitting !== null}>
                {submitting === "dev" ? "Проверяем…" : "Dev-вход"}
              </Button>
            </form>
          </details>
        ) : null}
      </section>
    </main>
  );
}
